/* eslint-disable react/destructuring-assignment */
import * as React from "react";

const BriefcaseSvg = ({ stroke = "black", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M6 6H6.005"
      stroke={stroke}
      strokeOpacity="0.75"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 3V2C8 1.73478 7.89464 1.48043 7.70711 1.29289C7.51957 1.10536 7.26522 1 7 1H5C4.73478 1 4.48043 1.10536 4.29289 1.29289C4.10536 1.48043 4 1.73478 4 2V3"
      stroke={stroke}
      strokeOpacity="0.75"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 6.5C9.5164 7.47949 7.77777 8.00165 6 8.00165C4.22223 8.00165 2.4836 7.47949 1 6.5"
      stroke={stroke}
      strokeOpacity="0.75"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 3H2C1.44772 3 1 3.44772 1 4V9C1 9.55229 1.44772 10 2 10H10C10.5523 10 11 9.55229 11 9V4C11 3.44772 10.5523 3 10 3Z"
      stroke={stroke}
      strokeOpacity="0.75"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WrenchSvg = ({ stroke = "black", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 11 11"
    fill="none"
    {...props}
  >
    <path
      d="M6.69984 2.50146C6.60823 2.59492 6.55691 2.72058 6.55691 2.85146C6.55691 2.98233 6.60823 3.10799 6.69984 3.20146L7.49984 4.00146C7.59331 4.09307 7.71897 4.14438 7.84984 4.14438C7.98072 4.14438 8.10638 4.09307 8.19984 4.00146L9.75284 2.44896C9.91284 2.28796 10.1843 2.33896 10.2443 2.55796C10.3954 3.10739 10.3869 3.68849 10.2197 4.23325C10.0526 4.77801 9.73375 5.26391 9.30054 5.63407C8.86732 6.00424 8.33764 6.24337 7.77347 6.32349C7.2093 6.4036 6.63399 6.32138 6.11484 6.08646L2.15984 10.0415C1.96093 10.2403 1.69117 10.352 1.40992 10.3519C1.12866 10.3519 0.858939 10.2401 0.660093 10.0412C0.461247 9.84229 0.349563 9.57254 0.349609 9.29128C0.349656 9.01002 0.46143 8.7403 0.660343 8.54145L4.61534 4.58646C4.38041 4.06731 4.2982 3.492 4.37831 2.92783C4.45842 2.36366 4.69756 1.83398 5.06772 1.40076C5.43789 0.967545 5.92378 0.648711 6.46855 0.481568C7.01331 0.314426 7.59441 0.305888 8.14384 0.456955C8.36284 0.516955 8.41384 0.787955 8.25334 0.948955L6.69984 2.50146Z"
      stroke={stroke}
      strokeOpacity="0.75"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SalesIcon = props => <BriefcaseSvg {...props} />;
export const ServiceIcon = props => <WrenchSvg {...props} />;

// Walks the parentType chain to the root and returns its name. If the
// opportunityType has no parent (single-level taxonomy), returns its own name.
export const getRootOpportunityTypeName = opportunityType => {
  if (!opportunityType) return null;
  let node = opportunityType;
  while (node?.parentType) {
    node = node.parentType;
  }
  return node?.name || null;
};

// Returns the appropriate icon for an opportunity type, walking up to the
// root parent so multi-level taxonomies still resolve to Sales / Service.
// Accepts either `opportunityType` (preferred) or `parentTypeName` (legacy).
export const OpportunityTypeIcon = ({ opportunityType, parentTypeName, ...props }) => {
  const resolved = opportunityType ? getRootOpportunityTypeName(opportunityType) : parentTypeName;
  const normalized = (resolved || "").toLowerCase();
  if (normalized === "sales") return <SalesIcon {...props} />;
  if (normalized === "service") return <ServiceIcon {...props} />;
  return null;
};

export default OpportunityTypeIcon;
